// extracted by mini-css-extract-plugin
module.exports = {"empty":"mobile_empty__UHFGf","emptyDesc":"mobile_emptyDesc__d3Di3"};